import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { DualPrice } from '../../../utils/DualPrice';

export const SearchingDriverInfoCard = ({ service, rate }) => {
  if (!service) return null;

  return (
    <div className="p-3 rounded-4 border mb-3 shadow-md" style={{ backgroundColor: '#1E293B', borderColor: 'rgba(14, 171, 176, 0.4)' }}>
      <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom border-secondary border-opacity-25">
        <span className="text-gray-300 small fw-medium">Servicio #{service.service_id?.slice(0, 8) || service.id}</span>
        <span className="badge rounded-pill px-2.5 py-1" style={{ backgroundColor: 'rgba(14, 171, 176, 0.2)', color: '#38BDF8', border: '1px solid #0EABB0' }}>
          Búsqueda Activa
        </span>
      </div>

      <div className="d-flex align-items-start gap-2 mb-2">
        <FontAwesomeIcon icon={faMapMarkerAlt} className="mt-1" style={{ color: '#0EABB0' }} />
        <div>
          <span className="text-gray-400 extra-small d-block">Origen</span>
          <span className="text-white small fw-semibold">{service.pickup?.address || service.pickup_address || 'Ubicación actual'}</span>
        </div>
      </div>

      <div className="d-flex align-items-start gap-2 mb-3">
        <FontAwesomeIcon icon={faMapMarkerAlt} className="mt-1" style={{ color: '#F87171' }} />
        <div>
          <span className="text-gray-400 extra-small d-block">Destino</span>
          <span className="text-white small fw-semibold">{service.dropoff?.address || service.dropoff_address || 'Destino seleccionado'}</span>
        </div>
      </div>

      {(service.offered_price || service.price || service.total_price) && (
        <div className="p-2.5 rounded-3 text-center mb-0" style={{ backgroundColor: 'rgba(14, 171, 176, 0.15)', border: '1px solid rgba(14, 171, 176, 0.35)' }}>
          <span className="text-gray-300 extra-small d-block font-medium">Monto Estimado / Ofertado</span>
          <span className="text-white h5 fw-bold mb-0">
            <DualPrice ves={service.offered_price || service.price || service.total_price} rate={rate} />
          </span>
        </div>
      )}
    </div>
  );
};

export default SearchingDriverInfoCard;
